import './recommendationLabel.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/RecommendationLabel/index.js